import { toQuery } from '@/utils/infrastructure';
import request from '@/utils/infrastructure/communication/request';

export async function queryList(params) {
  return request('/actionDigitalSignatureFieldMapping/paged', {
    params: toQuery(params),
  });
}

export async function queryEditItemDigitalSignature({ id, params }) {
  return request(`/actionDigitalSignatureFieldMapping/${id}`, {
    params: toQuery(params),
  });
}

export async function queryAddNewDigitalSignature(params) {
  return request.post(`/actionDigitalSignatureFieldMapping`, {
    data: params,
  });
}

export async function queryAddEditDigitalSignature(params) {
  return request.put('/actionDigitalSignatureFieldMapping', {
    data: params,
  });
}

export async function queryDeleteItem(id) {
  return request.delete(`/actionDigitalSignatureFieldMapping/${id}`, {});
}
